import { useMemo } from 'react';
import { locales } from '@i18n/index.ts';
import { useLocation } from 'react-router-dom';

export const normalizePathname = (pathname: string | null): string => {
  if (!pathname) return '';

  const segments = pathname.split('/').filter(Boolean);
  const firstSegment = segments[0];

  if (firstSegment && locales.includes(firstSegment)) {
    return segments.slice(1).join('/');
  }

  return segments.join('/');
};

export const useNormalizedPathname = () => {
  const location = useLocation();
  const pathname = location.pathname;

  return useMemo(() => normalizePathname(pathname), [pathname]);
};
